{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "korean": "Korean"
  },
  "menu": {
    "dashboard": "대시보드",
    "user": {
      "name": "회원정보관리",
      "user-list": "판매자정보관리",
      "seller-list": "판매자정보관리",
      "seller-daily-history": "오늘의판매기록관리",
      "buyer-list": "매입자정보관리",
      "corp-list": "업체정보관리",
      "buyer-manager-info": "담당자정보관리",
      "corpdb-list": "허용업체관리"
    },
    "product": {
      "name": "기준정보관리",
      "scrap-info": {
        "name": "고물관리",
        "scrap-list": "보물상고물조회",
        "scrap-setting": "보물상고물설정"
      },
      "price-info": {
        "name": "시세관리",
        "market-price-list": "시장고물시세관리",
        "market-price-info": "시장고물시세조회",
        "market-price-setting": "시장고물시세설정"
      },
      "report": {
        "name": "분석리포트관리",
        "report-list": "분석리포트조회",
        "report-setting": "분석리포트설정"
      },
      "special-info": {
        "name": "특별단가",
        "special-price-list": "오늘의 특별단가",
        "special-price-info": "오늘의 특별단가"
      }
    },
    "payment": {
      "name": "결제관리",
      "item-payment": "아이템결제내역조회",
      "banner-payment": "배너결제내역조회",
      "entry-payment": "입점비결제내역조회"
    },
    "admin": {
      "name": "관리자메뉴",
      "authority": {
        "admin-list": "관리자관리",
        "app-authority": "앱관리",
        "group-authority": "그룹권한관리",
        "menu-authority": "관리자메뉴관리"
      },
      "log": "로그조회"
    },
    "support": {
      "name": "고객지원관리",
      "banner": {
        "name": "배너관리",
        "product": "배너상품관리",
        "seller": "수거자배너",
        "buyer": "매입자배너"
      },
      "item": "아이템관리",
      "event": {
        "event": "이벤트관리",
        "winner": "당첨자관리"
      },
      "board": {
        "name": "게시판관리",
        "notice": "공지사항",
        "faq": "자주하는질문",
        "contact": "1:1문의관리"
      },
      "consult": {
        "corp-wait": "회원가입상담",
        "inquiry": "제휴/광고문의관리",
        "edu": "창업교육문의"
      }
    },
    "statistics": {
      "name": "통계분석",
      "signup": "회원가입통계",
      "payment": "결제통계",
      "call": "전화통계",
      "pickup": "수거통계 (수단,지역,고물)",
      "trade-scrap": "고물별거래통계",
      "trade-region": "지역별거래통계",
      "seller": {
        "name": "수거자통계",
        "call": "판매전화통계",
        "pickup-method": "수거수단통계",
        "pickup-region": "수거지역통계",
        "pickup-scrap": "수거고물통계",
        "alert": "판매자알림통계"
      },
      "buyer": {
        "name": "매입자통계",
        "region": "업체지역통계",
        "scrap": "취급고물통계",
        "alert": "매입자알림통계"
      }
    },
    "notification": {
      "user": "사용자알림관리",
      "system": "시스템알림관리",
      "name": "알림설정관리",
      "seller": "판매자알림관리",
      "buyer": "매입자알림관리",
      "auto": "자동발송알림관리",
      "admin": "관리자알림발송"
    },
    "terms": {
      "terms-main": "약관관리",
      "terms-history": "약관개정내역조회"
    },
    "auth": {
      "login": "로그인",
      "password-change": "비밀번호변경"
    },
    "push": {
      "name": "푸쉬알림관리"
    }
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "로그아웃",
    "profile": "프로필",
    "settings": "환경설정",
    "billing": "Billing",
    "helpAndSupport": "Help & support",
    "account": "계정정보",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  }
}
